"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateEmail = exports.EMAIL_REGEX = void 0;
exports.EMAIL_REGEX = /^([^<>()[\]\\.,;:\s@"]+(\.?))+(?!\.)@([a-z\-0-9]+\.)+[a-z]{2,}$/iu;
const isString = (v) => typeof v === 'string';
const validateEmail = (v) => isString(v) && exports.EMAIL_REGEX.test(v);
exports.validateEmail = validateEmail;
